import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  content
`

export const getCategoriesQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getCategories(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getCategories(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






